module.exports = __webpack_public_path__ + "static/img/1-1Z5291P155216.5fc4c48.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1-1Z5291P155216.jpg
// module id = Cm4Z
// module chunks = 0